module.exports = __webpack_public_path__ + "static/img/91BM-070-Morgan.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/91BM-070-Morgan.jpg
// module id = Tt8P
// module chunks = 0